/**
 * Date formatting utilities.
 * Shared across all components to avoid duplication and ensure null-safety.
 */ 

const MONTH_NAMES = [
  'Janvier',
  'Février',
  'Mars',
  'Avril',
  'Mai',
  'Juin',
  'Juillet',
  'Août',
  'Septembre',
  'Octobre',
  'Novembre',
  'Décembre',
];

/**
 * Format a datetime string as "DD Mois, YYYY" (e.g. "05 Mars, 2026").
 * Returns '' for null/undefined/invalid dates.
 *
 * @param {string|null|undefined} datetime
 * @returns {string}
 */
export const formatDate = (datetime) => {
  if (!datetime) return '';
  const date = new Date(datetime);
  if (isNaN(date.getTime())) return '';
  const day = date.getDate().toString().padStart(2, '0');
  const month = MONTH_NAMES[date.getMonth()];
  const year = date.getFullYear();
  return `${day} ${month}, ${year}`;
};

/**
 * Format a datetime string as "HH h MM min" (e.g. "14 h 30 min").
 * Returns '' for null/undefined/invalid dates.
 *
 * @param {string|null|undefined} datetime
 * @returns {string}
 */
export const formatTime = (datetime) => {
  if (!datetime) return '';
  const date = new Date(datetime);
  if (isNaN(date.getTime())) return '';
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  return `${hours} h ${minutes} min`;
};

/**
 * Format a datetime string as "DD/MM/YYYY" (short French format).
 * Returns '' for null/undefined/invalid dates.
 *
 * @param {string|null|undefined} datetime
 * @returns {string}
 */
export const formatDateShort = (datetime) => {
  if (!datetime) return '';
  const date = new Date(datetime);
  if (isNaN(date.getTime())) return '';
  return date.toLocaleDateString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
};
